import axios from 'axios';

// Separate client with no interceptors — auth calls must not trigger the 401 retry loop.
const authClient = axios.create({ baseURL: '/api', withCredentials: true, timeout: 10_000 });

export interface LoginOkResponse {
  status: 'ok';
  accessToken: string;
  user: { username: string };
}

export interface Login2faResponse {
  status: '2fa_required' | 'setup_required';
  pendingToken: string;
}

export type LoginResponse = LoginOkResponse | Login2faResponse;

export async function apiLogin(username: string, password: string): Promise<LoginResponse> {
  const { data } = await authClient.post<LoginResponse>('/auth/login', { username, password });
  return data;
}

export async function apiRefresh(): Promise<{ accessToken: string; user: { username: string } }> {
  const { data } = await authClient.post<{ accessToken: string; user: { username: string } }>('/auth/refresh');
  return data;
}

export async function apiLogout(): Promise<void> {
  await authClient.post('/auth/logout');
}

export async function api2faSetup(
  pendingToken: string,
): Promise<{ qrDataUrl: string; recoveryCodes: string[] }> {
  const { data } = await authClient.post<{ qrDataUrl: string; recoveryCodes: string[] }>(
    '/auth/2fa/setup',
    {},
    { headers: { Authorization: `Bearer ${pendingToken}` } },
  );
  return data;
}

export async function api2faVerify(
  pendingToken: string,
  code: string,
  type: 'totp' | 'recovery' = 'totp',
): Promise<{ accessToken: string; user: { username: string } }> {
  const { data } = await authClient.post<{ accessToken: string; user: { username: string } }>(
    '/auth/2fa/verify',
    { code, type },
    { headers: { Authorization: `Bearer ${pendingToken}` } },
  );
  return data;
}
